import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { AgtSocialMediaVM } from 'app/stores/ui/agt.socialmedia.ui.store';
import { Icon } from 'app/components/common/Icon';
import { formatNum } from 'app/utils';
import { SocialMediaBmRangeOptions } from './SocialMediaOptions';

export const TiktokListe = observer(() => {
	const { berichteUiiStore, agtSocialMediaUiStore, agenturListUiStore } = useStore();
	const [hasItems, setHasItems] = useState(false);
	const tm = new TableModel<AgtSocialMediaVM, number>();
	const cols: ITableColumn<AgtSocialMediaVM, number>[] = [];

	const currentYear = agtSocialMediaUiStore.currentYear;

	cols.push({
		label: 'Agentur',
		path: 'agt.name',
		sortBy: 'agt.name',
		render: AgenturNameCell,
	});

	cols.push({
		label: 'Screen Name',
		path: 'currTiktok.screenName',
		sortBy: 'currTiktok.screenName',
	});

	cols.push({
		label: 'Status',
		path: `currTiktok.status`,
		sortBy: `currTiktok.status`,
		agg: [{ aggType: AggregrationType.count }],
		render: (row: TableRow<AgtSocialMediaVM>) => <>{row.data.currTiktok && row.data.currTiktok.status === 1 ? <Icon iconClass="check" /> : ''}</>,
	});

	cols.push({
		label: 'Follower',
		path: `currTiktok.follower`,
		sortBy: `currTiktok.follower`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: 'Follower VJ',
		path: `prevTiktok.follower`,
		sortBy: `prevTiktok.follower`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Beiträge ${currentYear}`,
		path: `tiktokPostsYtd`,
		sortBy: `tiktokPostsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Sichtkontakte ${currentYear}`,
		path: `tiktokViewsYtd`,
		sortBy: `tiktokViewsYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	cols.push({
		label: `Erreichte Personen ${currentYear}`,
		path: `tiktokReachYtd`,
		sortBy: `tiktokReachYtd`,
		agg: [{ aggType: AggregrationType.avg }],
		format: formatNum,
	});

	tm.sortBy = 'agt.name';
	tm.setCols(cols);

	tm.idProperty = 'agtId';
	tm.idType = 'number';

	useEffect(() => {
		agtSocialMediaUiStore.loadBySelectedRange().then((vms) => {
			let items = vms.filter((x) => x.tiktoks.length > 0);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as AgtSocialMediaVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtSocialMediaUiStore, agtSocialMediaUiStore.selectedMinBm, agtSocialMediaUiStore.selectedMaxBm]);

	return (
		<>
			<SocialMediaBmRangeOptions />
			{!hasItems ? (
				<div className="pad-1rem">Keine Daten gefunden</div>
			) : (
				<>
					<Table stickyHeader={true} tm={tm} stickyFooter={true}></Table>
				</>
			)}
		</>
	);
});
